import React, { useEffect } from "react";
import Box from "@mui/material/Box";

import MainLayout1 from "Components/UI/Layout/MainLayout1";
import { ClientCard } from "../clients/client/clientcard/ClientCard";
import { ClientContextProvider } from "Context/Client";
import { Grid } from "@mui/material";

export function CompanySettings() {
  return (
    <ClientContextProvider isCompanySettings>
      <MainLayout1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1.0rem",
          }}
        >
          <Grid
            container
            rowSpacing={1}
            justifyContent="space-evenly"
            alignItems="stretch"
            columnSpacing={{ xs: 1, sm: 2, md: 1 }}
          >
            <Grid item xs={12} md={9}>
              <ClientCard />
            </Grid>
          </Grid>
        </Box>
      </MainLayout1>
    </ClientContextProvider>
  );
}
